import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import themeReducer from './slices/themeSlice';

// Safe localStorage parsing with error handling
const getSavedUser = () => {
  try {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  } catch (error) {
    console.warn('Failed to parse user from localStorage:', error);
    localStorage.removeItem('user'); // Clear invalid data
    return null;
  }
};

const getSavedTokens = () => {
  try {
    const savedTokens = localStorage.getItem('tokens');
    return savedTokens ? JSON.parse(savedTokens) : null;
  } catch (error) {
    console.warn('Failed to parse tokens from localStorage:', error);
    localStorage.removeItem('tokens'); // Clear invalid data
    return null;
  }
};

const getSavedTheme = (): 'light' | 'dark' => {
  try {
    const savedTheme = localStorage.getItem('theme');
    return (savedTheme === 'light' || savedTheme === 'dark') ? savedTheme : 'light';
  } catch (error) {
    console.warn('Failed to get theme from localStorage:', error);
    return 'light';
  }
};

const savedUser = getSavedUser();
const savedTokens = getSavedTokens();
const savedTheme = getSavedTheme();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
  },
  preloadedState: {
    auth: {
      isLoggedIn: !!(savedUser && savedTokens),
      user: savedUser,
      tokens: savedTokens,
      role: savedUser?.role || null,
      rehydrated: !!(savedUser && savedTokens),
    },
    theme: {
      mode: savedTheme,
    },
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
